import omit from 'lodash-es/omit';
import type { ChangeEvent } from 'react';
import { Field } from 'react-final-form';
import { PatternFormat } from 'react-number-format';

import { TextInput } from '../component-library/text-input/text-input';
import type { TextInputFieldProps } from '../component-library/text-input/text-input';

const formatPhoneNumber = (value: string) => value.replace(/[^0-9]/g, '');

const PHONE_FORMAT = '###-###-####';

export const PhoneInputField = ({
  label,
  name,
  helperText,
  ...props
}: Pick<
  TextInputFieldProps,
  'label' | 'name' | 'helperText' | 'id' | 'autoComplete'
>) => (
  <Field label={label} name={name} parse={formatPhoneNumber}>
    {({ meta, input }) => {
      const hasError = (meta.error || meta.submitError) && meta.touched;
      return (
        <PatternFormat
          customInput={TextInput}
          defaultValue={input.value ? formatPhoneNumber(input.value) : ''}
          label={label}
          name={name}
          format={PHONE_FORMAT}
          mask={'_'}
          {...props}
          {...omit(input, 'value')}
          type="tel"
          helperText={hasError ? meta.error || meta.submitError : helperText}
          error={hasError}
          onBlur={input.onBlur}
          onFocus={input.onFocus}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            input.onChange(formatPhoneNumber(event.target.value))
          }
          onValueChange={({ formattedValue }) => input.onChange(formattedValue)}
        />
      );
    }}
  </Field>
);
